import { logger } from '@adornis/base/logging.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { delay, getCurrentUserServer } from '@adornis/bh-util/util.js';
import { Permission } from '@adornis/buchungsheld-db/enums/roles.js';
import { sendInstitutionEmail } from '@adornis/buchungsheld-db/mails/sendInstitutionMail.js';
import { concatMap, from, merge, Observable, of, switchMap } from 'rxjs';
import { CustomMailRequest } from '../custom-mail-request.js';

export const sendCustomInstitutionMail = registerSubscription({
  operationName: 'sendCustomInstitutionMail',
  params: [
    { name: 'institutionID', type: () => String },
    { name: 'mails', type: () => [CustomMailRequest] },
  ],
  type: () => String,
  resolve: (institutionID: string, mailRequests: CustomMailRequest[]) => (): Observable<string> => {
    logger.info({ institutionID, mailRequests }, 'sendCustomInstitutionMail');
    return from(getCurrentUserServer()).pipe(
      switchMap(currentUser => {
        if (!currentUser?.hasPermission(Permission.SEND_INSTITUTION_MAILS, institutionID)) {
          throw new Error('no permission');
        }

        const tasks = mailRequests.map((mailRequest, i) => of({ id: i.toString(), mailRequest }));
        return merge(...tasks);
      }),
      concatMap(async ({ id, mailRequest }) => {
        for (const email of mailRequest.mailAddresses) {
          await sendInstitutionEmail({
            institutionID,
            subject: mailRequest.subject,
            content: mailRequest.content as any,
            email,
            cc: mailRequest.cc,
          });

          if (mailRequest.bcc) {
            for (const bcc of mailRequest.bcc)
              await sendInstitutionEmail({
                institutionID,
                subject: mailRequest.subject,
                content: mailRequest.content as any,
                email: bcc,
              });
          }
        }

        await delay(100);

        return id;
      }),
    );
  },
});
